export default __webpack_public_path__ + "static/college-audition-guide-preview-3-c87b3d31971e578a46e3465bf50067d6.jpg";